import { Host, h } from "@stencil/core";
export class CardActions {
    constructor() {
        this.position = '';
    }
    render() {
        return (h(Host, { key: '0ddde50f0b230e34ec5808381cee4512b3c819cf', class: "bal-card-actions" }, h("bal-button-group", { key: '55e2c1c888eb0a1c818565ae3d0e6d564a1320b1', class: "m-none", position: this.position }, h("slot", { key: 'c41d4ff9870e800acb34d11a0de30769f960ad02' }))));
    }
    static get is() { return "bal-card-actions"; }
    static get properties() {
        return {
            "position": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalCardActionsPosition",
                    "resolved": "\"\" | \"center\" | \"right\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The value of the button, which is submitted with the form data."
                },
                "getter": false,
                "setter": false,
                "attribute": "position",
                "reflect": false,
                "defaultValue": "''"
            }
        };
    }
}
